import React, { useEffect, useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import TabsUI from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { useStores } from '../stores';
import appStyles from '../../../config/appStyles.js';

const useStyles = makeStyles((theme) => appStyles.tabs(theme));

const Tabs = observer((props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState();
  const { orderStore, collectionStore, userStore } = useStores();
  const {
    hasOrders,
    currentOrder,
    currentIsModelKit,
    orderTypes,
    hasYoutubePlaylist,
  } = orderStore;
  const { showcases } = collectionStore;
  const { isLogged } = userStore;

  useEffect(() => {
    if (currentOrder && currentOrder.variantId) {
      orderStore.fetchProductInfo(currentOrder.variantId);
    }
  }, [currentOrder, orderStore]);

  const hasVideo =
    showcases.some((el) => el.video.source) || hasYoutubePlaylist;

  const links = [
    {
      label: t('subscription'),
      path: '/myarea/subscription',
      subscriptionRequired: true,
      alignRight: false,
    },
  ];

  if (
    currentOrder &&
    currentOrder !== orderTypes.backissue &&
    !currentIsModelKit &&
    !hasVideo
  ) {
    links.push({
      label: currentIsModelKit ? t('model') : t('collection'),
      path: '/myarea/collection',
      subscriptionRequired: true,
      alignRight: false,
    });
  }

  if (
    (currentIsModelKit || hasVideo) &&
    currentOrder !== orderTypes.backissue
  ) {
    links.push({
      label: t('assembleTutorials'),
      path: '/myarea/video-tutorials',
      subscriptionRequired: true,
      alignRight: false,
    });
  }

  links.push(
    isLogged
      ? {
          label: t('helpCenter'),
          path: '/myarea/help-center',
          subscriptionRequired: false,
          alignRight: false,
        }
      : {
          label: t('helpCenter'),
          path: '/myarea/p/contact-us',
          subscriptionRequired: false,
          alignRight: false,
        },
  );

  links.push({
    label: t('profile'),
    path: '/myarea/profile',
    subscriptionRequired: false,
    alignRight: false,
  });

  const findLinkByPage = useCallback(
    (path) => {
      return links.find((l) => !!l && l.path === path);
    },
    [links],
  );

  const handleChange = (event, value) => {
    const selectedTab = findLinkByPage(value);
    props.history.push(value);
    setCurrentTab(selectedTab);
  };

  return (
    <div className={classes.bar} position="static">
      <Box
        id="cp-tabs"
        className={classes.cpTabs}
        display="flex"
        justifyContent="center"
        width="100%">
        <TabsUI
          centered={true}
          className={classes.tabs}
          variant="scrollable"
          scrollButtons={'auto'}
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example"
          classes={{
            indicator: classes.indicator,
            root: classes.customTabsStyle,
            scrollable: classes.scrollable,
            scrollButtons: classes.scrollButtons,
            scrollButtonsDesktop: classes.scrollButtonsDesktop,
            flexContainer: classes.flexContainer,
          }}
          value={props.history.location.pathname}
          onChange={handleChange}>
          {links
            .filter(
              (l) =>
                !!l &&
                ((l.subscriptionRequired && hasOrders) ||
                  !l.subscriptionRequired),
            )
            .map((l, i) => (
              <Tab
                key={`navtab_${i}`}
                classes={{
                  selected: classes.selected,
                  root: classes.muiTabRoot,
                }}
                label={l.label}
                value={l.path}
              />
            ))}
        </TabsUI>
      </Box>
    </div>
  );
});

export default withRouter(Tabs);
